import React, { useEffect, useState } from 'react';
import { ReactComponent as Scanner } from "assets/img/svg/scanner.svg"
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput"
import { customStyle, getDropdowns, getPaidCash, getSumOfAllPaymentMode, inputAmountStyle, labelSyle, numberDecimalLimitRegex, 
    // validatePaymentMode 
} from "./constant"
import Error from '../errorHandlimg/Error';
import { cashValidtion } from '../validations/paymentModeValidation';
import { getConditionalCOllectSaveButton } from './common';

const CashView = ({ contextValue, isEditForm, isReceiptEdit = false, isView = false, rowId, handleClose = () => { } }) => {
    const [errorMgs, setErrorMgs] = useState();
    const [maxLimit, setMaxLimit] = useState()
    const [disable,setDisable]= useState(false)
    const {
        bankDropdown, paymentModeIdLimitList,
        setModifyPaymentModeData,
        paymentModeFormHandler,
        studentBasicDetails, currentPaymentMode, paymentModeForm, selectedChargesAmount, bankMasterId, setBalanceMode, setBalanceAmount, loader, setloader, setCollectPayment, balanceAmount, collectPayment,
        validatePaymentMode,
        disableAmountField
    } = contextValue
    const validatePayment = async () => {
        const error = await cashValidtion(paymentModeForm, balanceAmount, maxLimit, collectPayment)
        setErrorMgs(error)
        if (!error) {
            const isOk = await validatePaymentMode(studentBasicDetails, currentPaymentMode, paymentModeForm, selectedChargesAmount, bankMasterId, '', setBalanceAmount, setBalanceMode, setloader, setCollectPayment, balanceAmount, collectPayment)
            if (isOk) {
                isReceiptEdit===true && setModifyPaymentModeData((prev) => ({ ...prev, [rowId]: paymentModeForm }))
                isReceiptEdit && handleClose(true)
            }

        }
    }
    const getDifferenceOfmaxSum= async()=>{
        const sumAmount= await getSumOfAllPaymentMode(studentBasicDetails?.psid,'CSH');
        (paymentModeIdLimitList?.maxLimit-(getPaidCash(collectPayment)+sumAmount)<=0)&&setDisable(true)
    }
    useEffect(() => {
        paymentModeIdLimitList?.paymentModeIdList.includes(bankMasterId['Cash']) && setMaxLimit(paymentModeIdLimitList?.maxLimit)
        getDifferenceOfmaxSum();
    }, [])
    const disabled = !paymentModeForm?.paidAmount


    return (
        <>
            {!isView && !isReceiptEdit && <div className=" d-flex justify-content-between align-items-center mt-2">
                <span className="large-bold color-dark">Cash details</span>
            </div>}
            <div>
                <AInput
                    label={maxLimit ? `Enter Amount (Max. ₹${maxLimit})` : 'Enter Amount'}
                    type="text"
                    labelStyle={labelSyle}
                    value={paymentModeForm?.paidAmount}
                    customIcon={
                        <div className='large-semi-bold'>&#8377;</div>
                    }
                    customIconStyle={customStyle}
                    handler={(value) => {
                        if (
                            !value || parseFloat(value) > 0
                        ) {
                            paymentModeFormHandler('paidAmount',
                                value
                            )
                        }

                    }}
                    placeholder="Enter amount"
                    style={inputAmountStyle}
                    disabled={isView || isReceiptEdit === true || disable || disableAmountField }
                    regex={numberDecimalLimitRegex(10, 2)}
                />
            </div>
            {getConditionalCOllectSaveButton(disabled,
                paymentModeForm,
                validatePayment,
                isReceiptEdit,
                isEditForm,
                isView,
                setModifyPaymentModeData,
                rowId,
                handleClose)}
            <Error errorMgs={errorMgs} />
        </>
    )
}
export default CashView